import { Component, OnInit, input, ChangeDetectionStrategy } from '@angular/core';
import { MenuService } from '../menu.service';
import { Menu } from '../menu.model';
import { Subscription } from 'rxjs';

@Component({ standalone: false,
  selector: 'app-horizontal-menu',
  templateUrl: './horizontal-menu.component.html',
  styleUrls: ['./horizontal-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [ MenuService ]
})
export class HorizontalMenuComponent implements OnInit {
  readonly menuParentId = input<number|undefined>(undefined);
  readonly isRootMenu = input<boolean|undefined>(undefined);
  public menuItems?: Array<Menu>;

  private refreshMenuSubscription:Subscription;

  constructor(public menuService:MenuService) { 
    this.refreshMenuSubscription = this.menuService.refreshMenuSubject.subscribe(()=>{
      this.loadMenuItems();
    });
  }

  ngOnInit() {
    this.loadMenuItems();
  }

  ngOnDestroy(){
    if(this.refreshMenuSubscription) this.refreshMenuSubscription.unsubscribe();
  }

  private loadMenuItems(){
    this.menuItems = this.menuService.getHorizontalMenuItems();
    this.menuItems = this.menuItems.filter(item => item.parentId == this.menuParentId() && !item.hidden);
  }

}
